import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useSiteContext } from "../../contexts/SiteProvider";
import { ADMIN_USER_LOGO, LOGIN_PAGE_LOGO } from "../../services/ImageService";
import ToggleSwitch from "./ToggleSwitch";

interface HeaderProps {
  setIsOpen: (open: boolean) => void;
  setIsDark: (open: boolean) => void;
  isOpen: boolean;
  isDark: boolean;
  title: string;
}
const EFHeader: React.FC<HeaderProps> = ({
  setIsOpen,
  isOpen,
  setIsDark,
  isDark,
  title
}) => {
  const navigate = useNavigate();
  const basenav = "/";
  const { user, logout } = useSiteContext();
  const [mobileScreen, setMobileScreen] = useState<boolean>(
    window.innerWidth <= 768
  );
  const toggleTheme = () => setIsDark(!isDark);
  //console.log("user ", user);
  const navigateLink = (index: any) => {
    // navigate(basenav + "/" + index);
    navigate(basenav + index);
  };
  const handleLogout = () => {
    logout();
    navigateLink("");
  };
  useEffect(() => {
    const handleResize = () => {
      setMobileScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (window.innerWidth <= 768) {
      setIsOpen(false);
      // console.log("Mobile Screen")
    }
  }, [mobileScreen]);

  const MobileSideOpen = () => {
    setIsOpen(!isOpen);
  };
  return (
    <nav
      className="navbar is-transparent efl-main-nav"
      role="navigation"
      aria-label="main navigation"
    >
    
       <div className="navbar-brand">
        <div className="is-flex is-justify-content-space-between is-hidden-desktop">
 <div className="has-text-primary navbar-item header-title  ">{title} </div>
 
         
        </div>
        
       {/* <a className="">
              <span className=" mr-2">{user?.ename}</span>
            
           
            </a> */}
        <a
          className="navbar-burger is-size-3 "
          aria-label="menu"
          aria-expanded="false"
           data-target="navbarBasicExample"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>


    
      </div>
    


      <div id="navbarBasicExample" className="navbar-menu">
        <div className="navbar-start">
          <a onClick={() => setIsOpen(!isOpen)} className="navbar-item">
            <i className="fa fa-bars  "></i>
          </a>

          <div className="has-text-primary navbar-item header-title ">{title} </div>
          <p></p>
        
        </div>

        <div className="navbar-end">
          <div className="dark-switch-item mt-4">
            <ToggleSwitch isDark={isDark} toggleTheme={toggleTheme} />
          </div>
          <div className=" navbar-item  mr-1 smart-elf-notification">
            {/* <Notificaton /> */}

            <div className="dropdown is-active" key="s2"></div>
          </div>
          <div className="navbar-item has-dropdown is-hoverable ">
            <a className="navbar-link">
              <span className=" mr-2">{user?.ename}</span>
              <img
                src={ADMIN_USER_LOGO}
                alt=""
                className="is-64x64 is-rounded with-out-pointer"
              />
            </a>

            <div className="navbar-dropdown is-right">
              <a
                className="navbar-item"
                onClick={() => navigate("/admin/profile")}
              >
                <span className="icon mr-1">
                  <i className="fa fa-user-circle"></i>
                </span>{" "}
                Profile
              </a>
              <hr className="navbar-divider" />
              <a onClick={() => handleLogout()} className="navbar-item">
                <span className="icon mr-1">
                  <i className="fa fa-sign-out"></i>
                </span>{" "}
                Logout
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default EFHeader;
